/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$inboundSchema:
  z.ZodType<
    GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    "X-On-Behalf-Of": z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      "X-On-Behalf-Of": "xOnBehalfOf",
    });
  });
/** @internal */
export type GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$Outbound =
  {
    "X-On-Behalf-Of"?: string | undefined;
  };

/** @internal */
export const GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$outboundSchema:
  z.ZodType<
    GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$Outbound,
    z.ZodTypeDef,
    GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest
  > = z.object({
    xOnBehalfOf: z.string().optional(),
  }).transform((v) => {
    return remap$(v, {
      xOnBehalfOf: "X-On-Behalf-Of",
    });
  });

export function getConnectionApiV1SandboxGithubOauthConnectionsGetRequestToJSON(
  getConnectionApiV1SandboxGithubOauthConnectionsGetRequest:
    GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest,
): string {
  return JSON.stringify(
    GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$outboundSchema
      .parse(getConnectionApiV1SandboxGithubOauthConnectionsGetRequest),
  );
}
export function getConnectionApiV1SandboxGithubOauthConnectionsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'GetConnectionApiV1SandboxGithubOauthConnectionsGetRequest' from JSON`,
  );
}
